import Header from "../components/header";
import Sidebar from "../components/sidebar";
import UserDetails from "../components/UserDetails";

const UserDetailsPage = () => {
  return (
    <div>
        <Header />
        <Sidebar />
      <UserDetails />
    </div>
  );
};
export default UserDetailsPage;